export default "__VITE_ASSET__3a069f86__"